import { ClientPathSchema } from "@/features/dashboard/client/clientSchema";
import { IdentificationReuploadPage } from "@/features/dashboard/client/detail/components/identification-reupload/IdentificationReuploadPage";
import { IdentificationEditReturnTo } from "@/features/dashboard/client/identification-list/identificationListEnum";
import { IdentificationSearchSchema } from "@/features/dashboard/client/identification-list/identificationListSchema";
import { usePageTitle } from "@/hooks/usePageTitle";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

const IdentificationReuploadSearchSchema = IdentificationSearchSchema.extend({
  returnTo: z.enum(Object.values(IdentificationEditReturnTo)).optional(),
});

export const Route = createFileRoute(
  "/_dashboard/clients/$clientId/identification/reupload"
)({
  component: RouteComponent,
  parseParams: ClientPathSchema.parse,
  validateSearch: IdentificationReuploadSearchSchema,
});

function RouteComponent() {
  usePageTitle("本人確認画像再アップロード");
  return <IdentificationReuploadPage />;
}
